import { render } from "./bookmark_timeline.vue?vue&type=template&id=2b9c8ba0"
import script from "./bookmark_timeline.js?vue&type=script&lang=js&external"
export * from "./bookmark_timeline.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__